module.exports = (__webpack_require__(9))(925);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/antd/es/carousel/index.js from dll-reference antd_library
// module id = 888
// module chunks = 42